<template>
  <div class="text-center pageLoadingProgress" v-if="progressDisplay">
    <v-row justify="center">
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
        :width="5"
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<style>
.pageLoadingProgress {
  bottom: 50%;
  position: fixed;
  left: 50%;
}
</style>
<script>
export default {
  data: () => {
    return {
      progressDisplay: false,
      value: 0,
    };
  },
  methods: {
    show: function() {
      this.progressDisplay = true;
    },
    hide: function() {
      this.progressDisplay = false;
    },
  },
};
</script>
